import { useReducedMotion } from 'framer-motion';
import SearchIcon from '@/components/Icon/SearchIcon';
import IconButton from '@/components/IconButton/IconButton';
import Search, {
	SearchProps,
	useSearchVisibilityIfBarIsInvisible,
} from './Search';

const SearchButton = ({
	isSearchComponentMissing,
	searchResultTarget,
	showAfterSeconds = 0.5,
	onClickMeasure,
}: {
	isSearchComponentMissing: boolean;
	searchResultTarget: SearchProps['searchResultTarget'];
	showAfterSeconds?: number;
	onClickMeasure: () => void;
}) => {
	const reduceMotion = useReducedMotion();

	const { openSearch } = useSearchVisibilityIfBarIsInvisible();

	return (
		<>
			{isSearchComponentMissing && (
				<Search
					alwaysShowSearchBar={false}
					searchResultTarget={searchResultTarget}
				/>
			)}
			<IconButton
				className="absolute end-2 top-2 z-10 lg:end-4 lg:top-4"
				onClick={() => {
					openSearch();
					onClickMeasure();
				}}
				aria-label="Zoeken"
				title="Zoeken"
				icon={<SearchIcon />}
				variant="secondary"
				initial={{
					x: reduceMotion ? 0 : '75%',
					opacity: 0,
				}}
				animate={{
					x: 0,
					opacity: 1,
					transition: {
						delay: showAfterSeconds,
					},
				}}
			/>
		</>
	);
};

export default SearchButton;
